import { useQuery } from 'react-query'
import { api } from '../../../api'
import { type ProjectDomain } from '../../../../types/domain/project-domain'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { type TaskDomain } from '../../../../types/domain/task-domain'
import { type TaskSearchDomain } from '../../../../types/domain/task-search-domain'

interface FetchTasksParams {
  search?: string
}

export const fetchTasks = async (): Promise<ProjectDomain[]> => {
  const { data } = await api.get<PaginationDomain<ProjectDomain>>('/tasks')
  return data.data
}

export const fetchTaskSearch = async (
  search: string
): Promise<TaskSearchDomain[]> => {
  const { data } = await api.get<TaskSearchDomain[]>(`/tasks?search=${search}`)
  return data
}

const fetchTasksByProjectById = async (id: number) => {
  const response = await api.get<TaskDomain[]>(`/tasks/project/${id}`)
  return response.data
}

export const fetchTaskById = async (id: number) => {
  const response = await api.get<TaskDomain>(`/tasks/${id}`)
  return response.data
}

export const useTaskSearchQuery = ({ search }: FetchTasksParams) => {
  if (!search) {
    return useQuery('tasks', () => fetchTaskSearch(''), {
      staleTime: 1000 * 60 * 60 * 1,
      keepPreviousData: true,
    })
  }
  return useQuery('tasks', () => fetchTaskSearch(search), {
    staleTime: 1000 * 60 * 60 * 1,
    keepPreviousData: true,
  })
}

export const useTasksQuery = () => {
  return useQuery('tasks', () => fetchTasks(), {
    staleTime: 1000 * 60 * 60 * 1,
    keepPreviousData: true,
  })
}

export const useTaskByProjectIdQuery = (id: number) => {
  return useQuery(['task', id], () => fetchTasksByProjectById(id), {
    staleTime: 1000 * 60 * 60 * 1 /* 1 hour */,
    keepPreviousData: true,
  })
}

export const useTaskByIdQuery = (id: number) => {
  return useQuery(['task', id], () => fetchTaskById(id))
}
